import { AxiosResponse } from "axios";
import BaseService from "@/services/BaseService";
import ServiceResponseEntity from "./response-models/ServiceResponseEntity";
import ValidacionCertificacionTss from "@/models/ValidacionCertificacionTss";
import RequisitoBeneficio, {
  ParametrosValidacionRequisitosBeneficio,
} from "@/models/RequisitoBeneficio";
import ValidacionCedulaIt, {
  ValidacionCedulaItResp,
} from "@/models/ValidacionCedulaIt";
import ValidacionActaNacimiento, {
  ValidacionActaNacimientoResp,
} from "@/models/ValidacionActaNacimiento";
import ServiceResponse from "./response-models/ServiceResponse";

export default class ValidationService extends BaseService<any> {
  public constructor() {
    super("Validations");
  }

  public async validarRequisitosBeneficios(
    parametrosValidacionRequisitosBeneficio: ParametrosValidacionRequisitosBeneficio
  ): Promise<AxiosResponse<ServiceResponseEntity<RequisitoBeneficio>>> {
    return this.post(
      "ValidarRequisitosBeneficios",
      parametrosValidacionRequisitosBeneficio
    );
  }

  public async validateIngresoTardio(
    secuencia: string
  ): Promise<AxiosResponse<ServiceResponseEntity<ValidacionCertificacionTss>>> {
    return this.get("ValidateIngresoTardio", secuencia);
  }

  public async validateCedulaAfiliadoIT(
    validacionCedula: ValidacionCedulaIt,
    cedulas: { cedulaFrontal: File[]; cedulaTrasera: File[] }
  ): Promise<AxiosResponse<ServiceResponseEntity<ValidacionCedulaItResp>>> {
    return this.post(
      "ValidateCedulaIT",
      { validacionCedula },
      {
        cedulaFrontal: cedulas.cedulaFrontal,
        cedulaTrasera: cedulas.cedulaTrasera,
      }
    );
  }

  public async validateCedulaAfiliadoSobrevivencia(
    validacionCedula: ValidacionCedulaIt,
    cedulas: { cedulaFrontal: File[]; cedulaTrasera: File[] }
  ): Promise<AxiosResponse<ServiceResponseEntity<ValidacionCedulaItResp>>> {
    return this.post(
      "ValidateCedulaSobrevivencia",
      { validacionCedula },
      {
        cedulaFrontal: cedulas.cedulaFrontal,
        cedulaTrasera: cedulas.cedulaTrasera,
      }
    );
  }
  public async validateCedulaReverso(
    validacionCedula: ValidacionCedulaIt,
    cedulas: { cedulaFrontal: File[]; cedulaTrasera: File[] }
  ): Promise<AxiosResponse<ServiceResponseEntity<ValidacionCedulaItResp>>> {
    return this.post(
      "ValidateCedulaReverso",
      { validacionCedula },
      {
        cedulaFrontal: cedulas.cedulaFrontal,
        cedulaTrasera: cedulas.cedulaTrasera,
      }
    );
  }

  public async validateCesantia(
    secuencia: string
  ): Promise<AxiosResponse<ServiceResponseEntity<ValidacionCertificacionTss>>> {
    return this.get("ValidateCesantia", secuencia);
  }
  public async validateVejezAnticipada(
    secuencia: string
  ): Promise<AxiosResponse<ServiceResponseEntity<ValidacionCertificacionTss>>> {
    return this.get("ValidateVejezAnticipada", secuencia);
  }

  public async validateActaNacimiento(
    validacionActaNacimiento: ValidacionActaNacimiento,
    actaNacimiento: { acta: File[] }
  ): Promise<
    AxiosResponse<ServiceResponseEntity<ValidacionActaNacimientoResp>>
  > {
    return this.post(
      "ValidateActaNacimiento",
      { validacionActaNacimiento },
      { acta: actaNacimiento.acta }
    );
  }
}
